exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divtotal[data-v-143ac76c]{width:100%;margin-bottom:15px;height:38px}.texttotal[data-v-143ac76c]{background-color:#f5f5f5;padding:6px 0 6px 12px;width:50%;border-left:4px solid #f5f5f5;border-bottom:4px solid #f5f5f5;border-top:4px solid #f5f5f5;color:#7a7a7a;float:left;border-radius:4px 0 0 4px}.numerototal[data-v-143ac76c]{padding:6px 12px 6px 0}.numeroinput[data-v-143ac76c],.numerototal[data-v-143ac76c]{border:4px solid #f5f5f5;width:50%;color:#7a7a7a;float:left;border-radius:0 4px 4px 0}.cambio[data-v-143ac76c]{font-size:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-143ac76c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modals/Modalcashback.vue
// module id = 534
// module chunks = 0